import store from '../store'

export const getVnSecret = () => {
  const state = store.getState();
  if(state.legacyUser){
    return state.legacyUser.vnSecret
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/utility/utils.js